import React, { useRef, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Box,
  InputAdornment,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import companyLogo from "../../assets/images/nirantara_logo_new.svg";
import VerifyOtpPage from "./VerifyOTP";
import ResetPassword from "./ReSetPassword";
import LoginSlider from "./LoginSlider";
import "./login.css";
import { api, post } from "../../utils/api";

const LoginWelcomePage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showNewUserPassword, setNewUserPassword] = useState(false);
  const [passwordAction, setPasswordAction] = useState("reset");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [sessionId, setSessionId] = useState(null)
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [terms, setTerms] = useState(false);

  const passwordRef = useRef(null);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLoginClick = () => {
    setShowOtp(true);
    setShowResetPassword(false);
  };

  const handleForgotPassword = () => {
    setShowResetPassword(true);
    setPasswordAction("reset");
  };

  const handleNewUserPassword = () => {
    setShowResetPassword(true);
    setPasswordAction("create");
  };

  const handleBackToLogin = () => {
    setShowResetPassword(false);
    setShowOtp(false);
  };

  const handleLogin = async () => {
    setError(""); // Clear previous error
    if (!email || !password) {
      setError("Email and Password are required");
      return;
    }

    setShowResetPassword(false);

    try {
      const response = await post(`${api}/api/auth/login`, { email, password });
      const { message, terms,sessionId } = response.data;
      setSessionId(sessionId)
      setTerms(terms);
      setSnackOpen({
        open: true,
        message: response?.data?.message,
        severity: "success",
      });
      setShowOtp(true);
    } catch (error) {
      console.error("Login Error:", error);
      setSnackOpen({
        open: true,
        message: error?.response?.data?.message || "Invalid email or password",
        severity: "error",
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin();
      e.preventDefault();
    }
  };

  console.log(passwordAction, "passwordAction");

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        margin: "0",
        padding: "0",
        display: "flex",
        overflow: "hidden",
      }}
    >
      {/* Left Section - Image (remains same) */}
      <Grid
        item
        sx={{
          flex: 1,

          padding: 0,
          margin: 0,
        }}
      >
        <LoginSlider />
      </Grid>

      {/* Right Section - Toggle between Login and OTP */}
      <Grid
        item
        sx={{
          display: "flex",
          padding: "60px 40px 40px 40px",
          justifyContent: "center",
          width: "37.85%",
          bgcolor: "rgba(255, 255, 255, 1)",
          position: "relative",
          // backgroundColor: "rgb(196, 230, 240)",
          overflow: "auto",
        }}
      >
        <Box sx={{ width: "100%" }}>
          {showResetPassword ? (
            <ResetPassword
              onBack={handleBackToLogin}
              actionType={passwordAction}
            />
          ) : showOtp ? (
            <VerifyOtpPage
              email={email}
              password={password}
              terms={terms}
              onBack={handleBackToLogin}
              sessionId={sessionId}
            />
          ) : (
            <>
              <p className="main-heading">WELCOME TO VAJRA!</p>
              <p className="subheading">Please Use your Registered Email</p>

              {/* Email Input */}
              <p className="input-label">Email ID</p>
              <TextField
                fullWidth
                placeholder="Email ID"
                variant="outlined"
                sx={{ mb: 2, marginTop: "-0.9rem" }}
                InputProps={{ sx: { height: "45px" } }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    passwordRef.current?.focus();
                  }
                }}
              />

              {/* Password Input */}
              <p className="input-label">Password</p>
              <TextField
                fullWidth
                placeholder="Password"
                variant="outlined"
                type={showPassword ? "text" : "password"}
                sx={{ mb: 1 }}
                inputRef={passwordRef}
                InputProps={{
                  sx: { height: "45px", marginTop: "-0.9rem" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleTogglePassword} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => handleKeyDown(e)}
              />

              {/* Forgot Password */}

              <Box
                sx={{
                  display: "flex",
                  alignItems: "right",
                  justifyContent: "right",
                }}
              >
                {/* <p onClick={handleNewUserPassword} className="new-user">
                  New User?
                </p> */}
                <p
                  onClick={handleForgotPassword}
                  className="last-label-bold"
                  style={{ cursor: "pointer" }}
                >
                  Forgot Password?
                </p>
              </Box>

              {/* Login Button */}
              <Button
                fullWidth
                variant="contained"
                // onClick={handleLoginClick}
                onClick={handleLogin}
                sx={{
                  bgcolor: "#EB7E0E",
                  color: "#fff",
                  textTransform: "none",
                  py: 1.2,
                  borderRadius: "10px",
                  "&:hover": { bgcolor: "#EB7E0E" },
                }}
              >
                Login
              </Button>
            </>
            //   ) : (
            //     // OTP Component
            //     <VerifyOtpPage />
          )}

          {/* Footer (remains same for both views) */}

          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              position: "absolute",
              bottom: "20px",
              left: 0,
              right: 0,
              textAlign: "center",
              color: "#838383",
              fontSize: "11px",
              ml: 0,
            }}
          >
            Powered by
            <span style={{ marginLeft: "0.25rem" }}>
              <img
                src={companyLogo}
                alt="Company Logo"
                style={{
                  height: "32px",
                  display: "inline-block",
                  marginTop: "-5px",
                }}
              />
            </span>
          </Typography>
        </Box>
      </Grid>

      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setSnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default LoginWelcomePage;
